import { Grid, Paper, Typography,Rating, Box, CircularProgress } from '@mui/material';
import './App.css';
import { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles';
import Form from './components/Form';
import Leave_review from './components/Leave_review';
import LanguageSwitcher from './components/LanguageSwitcher';
import axios from 'axios'
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import { linguaT } from "./helpers/linguaT";

function App() {
  const [rate, setRate] = useState(null)
  const showForm = (rate != null && rate < 4)
  const showWhereReview = (rate != null && rate > 3)
  const showBack = (rate !== null)
  const url = "https://www.i-salon.eu/api/customer_satisfation/impostazioni/?ID_punto="
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [selected_lang, setSelected_lang] = useState("ita")
  const [all_data, setAll_data] = useState({nome: "", colore: "", logo: "", whatsapp: "", email: "", facebook: "", google: ""})
  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);
  let idSalone = urlParams.get("i")

  const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
      color: all_data.colore,
    },
    '& .MuiRating-iconHover': {
      color: all_data.colore,
    },
    '&	.MuiRating-iconEmpty' :{
      color: all_data.colore,
      opacity: 0.4

    }
  });

  useEffect(() => {
    axios.get(url + idSalone)
    .then(function (response) {
      if(response.data.Risposta === "Ok"){
        const { Nome, App_Colore_primario, Logo, Url_Facebook, Url_Google, Email, Whatsapp,ID_Facebook } = response.data.Dati
        setAll_data({
          nome: Nome, 
          colore: App_Colore_primario, 
          logo: Logo, 
          whatsapp: Whatsapp, 
          email: Email, 
          facebook: Url_Facebook,
          facebook_id: ID_Facebook,
          google: Url_Google
        })
        
        document.title = Nome
        let slug = "ita"; 
          switch (response.data.Dati.ID_lingua_culture) {
            case "1": slug = "ita"; break;
            case "2": slug = "eng"; break;
            case "3": slug = "spa"; break;
            case "4": slug = "deu"; break;
            case "5": slug = "arb"; break;
            default: slug = "ita"; break;
        }

        setSelected_lang(slug)
        setLoading(false)
        setError(false)
      }else{
        setError(true)
      }
    }).catch(function (error) {
      setError(true)
    })
  }, []);
  
  const img_style= { 
    logo: {
      backgroundImage: `url("https://www.wegest.it/api/read/?T=${all_data.logo}")`,
      width: "100%",
      maxWidth: "350px",
      height: "80px",
      margin: "20px auto",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }
  }

  const style = {
    root: {
      height: window.innerHeight,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      overflow: "scroll"
    },
    grid:{
      p:2
    },
    left: {
      display: "flex",
      flexDirection: "column",
      margin: "auto"
    },
    left_rating:{
      margin: "auto",
      mt: 4,
      transform: "scale(1.5)",
    },
  }

  const goBack = () =>{
    setRate(null)
  }
  return (
    <Paper className="App" sx={style.root}>
      {
        showBack && 
        <Box sx={{position: "absolute", top: 30, left: 30}} onClick={goBack}>
          <BsFillArrowLeftCircleFill style={{color: all_data.colore}} size={36} />
        </Box>
      }
      <LanguageSwitcher selectedLanguage={selected_lang} setLanguage={new_selection => setSelected_lang(new_selection)} />
      {
        !error && !loading &&
        <Grid container sx={style.grid}>

          <Grid item xs={12} className="rate" style={style.left}>
            <div style={img_style.logo}></div>

            { showForm && 
              <Form 
                whatsapp={all_data.whatsapp} 
                email={all_data.email} 
                color={all_data.colore} 
                lang={selected_lang}
              /> 
            }

            { showWhereReview && 
              <Leave_review 
                facebook_link={all_data.facebook}
                facebook_id={all_data.facebook_id} 
                google={all_data.google} 
                lang={selected_lang}
              /> 
            }

            {
              !rate && 
              <Box>
                <Typography variant="h5" component="h2">
                  { linguaT("general_experience", selected_lang, []) }
                </Typography>
              
                <StyledRating 
                  sx={style.left_rating} 
                  size="large" 
                  name="no-value" 
                  value={rate} 
                  onChange={(e)=>setRate(e.target.value)}
                />
              </Box>
            }
          </Grid>

        </Grid>
      }
      
      {
        error &&
        <Grid container sx={style.grid}>
          <Typography>
            { linguaT("loading_error", selected_lang, []) }
          </Typography>
        </Grid>
      }

      {
        !error && loading &&
        <Grid container sx={style.grid}>
          <Grid item xs={12}>
            <CircularProgress />
          </Grid>
        </Grid>

      }
    </Paper>
  );
}

export default App;
